import { render, staticRenderFns } from "./GripAnalysisStrategies.vue?vue&type=template&id=36cd2b95"
import script from "./GripAnalysisStrategies.vue?vue&type=script&lang=ts"
export * from "./GripAnalysisStrategies.vue?vue&type=script&lang=ts"
import style0 from "./GripAnalysisStrategies.vue?vue&type=style&index=0&id=36cd2b95&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports